import i18n from "../i18n";

export const Message = (props) => {
  const { data, id } = props;

  return i18n(id, data);
};
